import { ExpandableText } from "@punchup/ui-common/components/common";

export default ExpandableText;
